<template>
  <!-- <div :id="participantkey + publication[0]" class="all_video_tracks" > -->
  <div :id="this.videoID" class="all_video_tracks" >
    <!-- <span v-show="ready && publication[1].kind == 'video'">{{ participantkey }}</span> -->
  </div>
</template>

<script>
import { CSS3DRenderer, CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer'
import * as THREE from 'three';
// import {cross,dot} from 'mathjs';

export default {

  name:"ThreeDimensionalVideoTrack",
  props: ["participantkey","publication","screenTrack","trackindex","scene","scene2","camera","geolocation"],
  data(){
    return{
      ready: false,
      videoID:"",
      ccsElement:null,
      mesh:null,
      mesh1:null
    }
  },
  created(){
    this.videoID = this.participantkey + this.publication[0]
  },
  mounted(){

    // console.log(this.participantkey)

    const videoruimte = document.getElementById("video_container");

    let videocontainer = document.getElementById(
      this.participantkey + this.publication[0]
    );

    // console.log(this.participantkey , this.publication[0])

    // console.log(videocontainer);
    // console.log(this.participantkey,this.publication[0]);
    videocontainer.appendChild(this.$props.publication[1].track.attach());
    videocontainer.classList.add("threeVideotrack");

    this.cssElement = new CSS3DObject(videocontainer);

    let randomLat = this.getRndInteger(0,60);
    let randomLong = this.getRndInteger(-180,180);

    if(this.geolocation != undefined){
      randomLat = this.geolocation.la
      randomLong = this.geolocation.lo
    }

    // console.log(randomLat, randomLong);
    
    const position = this.calcPosFromLatLonRad(randomLat, randomLong,3);
 
    this.cssElement.scale.set(0.005,0.005,0.005);
    this.cssElement.opacity = 0.999;

    this.cssElement.position.set(position[0], position[1], position[2]);

  
    // this.cssElement.rotation.x = 0;

    this.scene2.add(this.cssElement);
    
    const material = new THREE.MeshPhongMaterial({
        opacity	: 0,
        color	: new THREE.Color('black'),
        blending: THREE.NoBlending,
        side	: THREE.DoubleSide,
    });
    const geometry = new THREE.PlaneGeometry(350, 400 );


    // const geometry = new THREE.ShapeGeometry(newShape);


    var path = new THREE.Shape();
    path.moveTo(-110, -165); // links onder
    path.lineTo(-10,-165); // begin van de punt
    path.lineTo(17,-250); // punt
    path.lineTo(45,-165); // rechterkant van de punt
    path.lineTo(130,-165); // rechtsonder1
    path.lineTo(218,250); //rechts boven
    path.lineTo(-180,250); // links boven
    // path.lineTo(25,0);


    const geometry1 = new THREE.ShapeGeometry( path );
    this.mesh1 = new THREE.Mesh( geometry1, material ) ;
    // mesh1.scale.copy( this.cssElement.scale );

    this.mesh1.position.copy( this.cssElement.position );
    this.mesh1.rotation.copy( this.cssElement.rotation );
    this.mesh1.scale.copy( this.cssElement.scale );
    this.mesh1.name = "backpane"

    this.scene.add( this.mesh1 );

    this.mesh = new THREE.Mesh(geometry, material );


    this.mesh.position.copy( this.cssElement.position );
    this.mesh.rotation.copy( this.cssElement.rotation );
    this.mesh.scale.copy( this.cssElement.scale );
    this.mesh.castShadow = false;
    this.mesh.receiveShadow = true;
    this.mesh.name = "backpane"


    // console.log(this.mesh)
    // this.scene.add( this.mesh );


    this.ready = true;
    // this.rerender();
  },

  beforeDestroy(){
    // console.log("Destroy",this.cssElement);
    this.scene2.remove(this.cssElement);
    this.scene.remove(this.mesh)
    this.scene.remove(this.mesh1)
  },

  methods: {
    getRndInteger: function(min, max) {
      return Math.floor(Math.random() * (max - min) ) + min;
    },

    rerender: function(){

    },

    calcPosFromLatLonRad: function(lat,lon,radius){
  
      var phi   = (90-lat)*(Math.PI/180);
      var theta = (lon+180)*(Math.PI/180);

      const x = -(radius * Math.sin(phi)*Math.cos(theta));
      const z = (radius * Math.sin(phi)*Math.sin(theta));
      const y = (radius * Math.cos(phi));
    
      return [x,y,z];

    },

    angle: function(cx, cy, ex, ey) {
      var dy = ey - cy;
      var dx = ex - cx;
      var theta = Math.atan2(dy, dx); // range (-PI, PI]
      theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
      //if (theta < 0) theta = 360 + theta; // range [0, 360)
      return theta;
    },


  },

  sockets: {
    location: function(data) {
      console.log("update,location")
      // console.log(data.user,data.coordinates.la,data.coordinates.lo)


      // let randomLat = data.coordinates.la
      // let randomLong = data.coordinates.lo
      // const position = this.calcPosFromLatLonRad(randomLat, randomLong,3);

      // this.cssElement.position.set(position[0], position[1], position[2]);
      // this.mesh1.position.copy( this.cssElement.position );

      // const meters = this.distanceBetweenTwoGeo(data.coordinates.la,data.coordinates.lo);
      // this.others.push(`${data.user} is in ${data.city} ${meters}`);

    }
  }


}
</script>

<style>

.threeVideotrack {
  /* display: inline-block; */
  /* position: relative; */
  width: 500px;
  height: 500px;
  background-color: #FFD959;
  box-sizing: border-box;
  -webkit-clip-path: polygon(14% 0, 93% 0, 76% 83%, 59% 83%, 53% 100%, 47% 83%, 28% 83%);
  clip-path: polygon(14% 0, 93% 0, 76% 83%, 59% 83%, 53% 100%, 47% 83%, 28% 83%); 
  
  /* width: 470px; */
  /* height:470px; */
  /* background-color: salmon; */
}
.threeVideotrack > video {
  position: absolute;
  top: 13px; 
  left: 16px; 
  width: 470px; 
  height: 470px; 
  -webkit-clip-path: polygon(14% 0, 93% 0, 76% 83%, 59% 83%, 53% 100%, 47% 83%, 28% 83%);
  clip-path: polygon(14% 0, 93% 0, 76% 83%, 59% 83%, 53% 100%, 47% 83%, 28% 83%);
}


</style>
// .threeVideotrack > video {
//   position: absolute;
//   top: 13px; /* equal to border thickness */
//   left: 16px; /* equal to border thickness */
//   width: 470px; /* container height - (border thickness * 2) */
//   height: 470px; /* container height - (border thickness * 2) */
//   -webkit-clip-path: polygon(14% 0, 93% 0, 76% 83%, 59% 83%, 53% 100%, 47% 83%, 28% 83%);
//   clip-path: polygon(14% 0, 93% 0, 76% 83%, 59% 83%, 53% 100%, 47% 83%, 28% 83%);
// }
  
  
  
  // .threeVideotrack {
  //   display: inline-block;
  //   /* position: relative; */
  //   width: 500px;
  //   height: 500px;
  //   background-color: #FFD959;
  //   box-sizing: border-box;
  //   -webkit-clip-path: polygon(14% 0, 93% 0, 76% 83%, 59% 83%, 53% 100%, 47% 83%, 28% 83%);
  //   clip-path: polygon(14% 0, 93% 0, 76% 83%, 59% 83%, 53% 100%, 47% 83%, 28% 83%);
  // }